import { Button, Card, CircularProgress, Grid, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadImage } from '../../../../components';
import { addDataManajemen, getKategoriManajemen } from '../../../../redux/actions/manajemenPerusahaanActions';

const TambahData = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [submit, setSubmit] = useState(false);
    const {kategori} = useSelector(({manajemenPerusahaan}) => manajemenPerusahaan)
    const [params, setParams] = useState({
        name:"",
        img:"",
        img_preview: '',
        position_id:"",
        position_en:"",
        about_id:"",
        about_en:"",
        category:"",
        quote: "",
        quote_from: ""
    });
    useEffect(() => {
      dispatch(getKategoriManajemen({paginate: false}))
    }, [dispatch])
    
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        addDataManajemen(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    };
    const handleChangeFoto = (file, path) => {
        setParams((pref) => ({
            ...pref,
            img: file,
            img_preview: path
        }));
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Tambah Data</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        <ValidatorForm
                            onSubmit={handleFormSubmit}
                            className="w-full"
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={handleChangeFoto}
                                        label="Unggah Foto"
                                        preview={
                                            params?.img_preview
                                        }
                                        required={true}
                                        aspectRatio={488/509}
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 488 x 509'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel htmlFor="name" className="mb-4">
                                        Nama{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextValidator
                                        id="name"
                                        placeholder="Nama"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="name"
                                        value={params.name || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Nama terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel htmlFor="category" className="mb-4">
                                        Kategori{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <Select
                                        labelId="category"
                                        value={params.category}
                                        onChange={handleChange}
                                        variant="outlined"
                                        className="w-full"
                                        name="category"
                                        displayEmpty
                                    >
                                        <MenuItem value="" selected disabled>
                                            Pilih Kategori
                                        </MenuItem>
                                        {kategori?.map((item) => (
                                            <MenuItem
                                                value={item?.mgc_code}
                                                key={item?.mgc_code}
                                            >
                                                {item?.name_id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="position_id"
                                        className="mb-4"
                                    >
                                        Jabatan [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="position_id"
                                        placeholder="Jabatan"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="position_id"
                                        value={params.position_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Jabatan terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="position_en"
                                        className="mb-4"
                                    >
                                        Jabatan [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="position_en"
                                        placeholder="Jabatan"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="position_en"
                                        value={params.position_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Jabatan terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="about_id"
                                        className="mb-4"
                                    >
                                        Deskripsi [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="about_id"
                                        placeholder="Deskripsi profil"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="about_id"
                                        value={params.about_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Deskripsi terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={16}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="about_en"
                                        className="mb-4"
                                    >
                                        Deskripsi [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="about_en"
                                        placeholder="Deskripsi profil"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="about_en"
                                        value={params.about_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Deskripsi terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={16}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="quote"
                                        className="mb-4"
                                    >
                                        Kutipan(Quote)
                                    </InputLabel>
                                    <TextValidator
                                        id="quote"
                                        placeholder="Kutipan(Quote)"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="quote"
                                        value={params.quote || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="quote_from"
                                        className="mb-4"
                                    >
                                        Pengutip
                                    </InputLabel>
                                    <TextValidator
                                        id="quote_from"
                                        placeholder="Pengutip"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="quote_from"
                                        value={params.quote_from || ''}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent="flex-end"
                                        className="flex-column-reverse flex-md-row"
                                    >
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                color="primary"
                                                className="text-primary w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                                onClick={() => history.goBack()}
                                            >
                                                Batal
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="text-white w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                            >
                                                {submit ? (
                                                    <CircularProgress
                                                        color="primary"
                                                        size={25}
                                                    />
                                                ) : (
                                                    'Simpan'
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default TambahData;
